import React, {Component} from 'react';
import {gpn} from "../GPN"
import axios from "axios";
import config from "../config";
import Back from "../sections/Back";
import Icon from "../sections/MUI/Icon";
import {toast} from "react-toastify";

class ChatMessage extends Component {

    messageBox = React.createRef();
    state = {
        id: this.props.params.id,
        messages: [],
        message: ""
    };
    scrollToBottom = () => {
        this.messagesEnd.scrollIntoView();
    }

    componentDidMount() {
        this.getMessages();
    }


    getMessages() {
        axios.get(`${config.api}/admin/goftino/messages?token=${config.token}&id=${this.state.id}`)
            .then(r => {
                this.setState({messages: r.data});

                this.scrollToBottom();
            })
            .catch(err => {
                config.handleError(err);
            });
    }

    send() {
        let {id, message} = this.state;
        console.log("message: ", message);
        message = message ? message.toString().trim() : "";
        if (message.length > 0) {
            let params = new URLSearchParams();
            params.append("chatId", id);
            params.append("message", message);
            this.setState({
                message: ""
            });
            axios.post(`${config.api}/admin/goftino/message?token=${config.token}`, params)
                .then(r => {
                    toast.success("پیام با موفقیت ارسال شد.");
                    this.getMessages();
                    setTimeout(() => {
                        this.scrollToBottom();
                    }, 5000)
                })
                .catch(err => {
                    this.setState({message});
                    config.handleError(err);
                });

        } else {
            toast.error("متن پیام نمی تواند خالی باشد!")
        }
    }

    render() {
        const {messages, message} = this.state;
        return (
            <div className="chat-messages">
                <Back {...this.props}/>

                <br/>
                <Icon i="sync" onClick={() => this.getMessages()} className="sync-icon"/>
                <br/>
                <div className="list">
                    {messages.map((m, i) =>
                        <article key={"message" + i}
                                 className={m.sender === "کاربر" ? "user" : "operator"}>
                            <div className={m.sender === "کاربر" ? "message user" : "message operator"}>

                                <pre>{m.content}</pre>
                                <div className="footer">
                                    <div className="row">
                                        {
                                            m.sender !== "کاربر" ?
                                                <div className="seen">
                                                    <Icon i={m.seen ? "check-double" : "check"}
                                                          className={m.seen ? "yes-seen" : "no-seen"}/>
                                                </div>
                                                : null
                                        }

                                        <div className="date">{m.date}</div>
                                    </div>
                                </div>
                            </div>
                        </article>
                    )}
                    <div className="message-box"
                         ref={el => this.messagesEnd = el}>
                        <div className="row">
                            <div className="col">

                                <textarea name="message"
                                          id="message"
                                          placeholder="متن پیام ..."
                                          rows="1"
                                          onChange={e => {
                                              this.setState({message: e.target.value.slice(0, 2000)});
                                          }}
                                          value={message}>{message}</textarea>
                            </div>
                            <div className="col-auto">
                                <Icon i="reply" className="send-icon" onClick={() => this.send()}/>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default gpn(ChatMessage);